import payments from './models/PaymentHelper';

export default { payments };
